// Traductions de l'outil : window.PTX_T (texte français → traduction), écrit par le thème hors français.
var ptxT = window.ptxT || (window.ptxT = (s) => (window.PTX_T && window.PTX_T[s]) || s);
/*
 * Printtex : onglet « Idées » de l'outil de personnalisation (modèles de texte prêts à personnaliser, sans IA).
 * Le client choisit un modèle (EVJF, anniversaire, club de sport…), change prénom / date / nom / numéro, et le
 * modèle est placé dans la zone d'impression. Modèles et formes : assets/printtex-modeles.json.
 * Règle de Karim : jamais coupé, jamais hors de la zone ; un texte long est réduit automatiquement.
 * Seul lien avec l'outil : window.PrinttexPerso (fin de printtex-perso.js). Un modèle posé est un groupe Fabric
 * ppType « modele » ; ppProps = { id, valeurs, couleur } suffit à le recréer (annuler, création retrouvée).
 */
(() => {
  const source = document.currentScript?.dataset.modeles;
  const sourceTF = document.currentScript?.dataset.tempsForts;
  const sourceTendances = document.currentScript?.dataset.tendances;
  const LARGEUR = 360; // largeur max d'une ligne (unités du modèle, avant mise à l'échelle dans la zone)
  let P = null;
  let biblio = null;
  let chargement = null;
  let filtre = 'tout';
  let vignettesFonce = null; // teinte du vêtement pour laquelle les vignettes ont été dessinées

  const charger = () => {
    chargement ||= Promise.all([
      fetch(source).then((r) => r.json()),
      sourceTF ? fetch(sourceTF).then((r) => r.json()).catch(() => null) : null,
      sourceTendances ? fetch(sourceTendances).then((r) => r.json()).catch(() => null) : null,
    ]).then(([j, tf, tendances]) => { biblio = j; biblio.moment = enCeMoment(tf); ajouterTendances(tendances); return j; });
    return chargement;
  };

  // Temps forts en cours : calcul commun à tout le site (assets/printtex-temps-forts.js).
  // Tendances (expressions du moment, fichier renouvelé chaque mois) : un modèle par expression, 4 styles.
  const STYLES = [
    (t) => [{ t, f: 'Bangers', s: 84, up: true, sp: 10 }, { rang: [{ forme: 'etoile', h: 14, col: 'accent' }, { forme: 'etoile', h: 20, col: 'accent' }, { forme: 'etoile', h: 14, col: 'accent' }], g: 6 }],
    (t) => [{ t, f: 'Pacifico', s: 76 }, { forme: 'trait', h: 4, col: 'accent', g: 6 }],
    (t) => [{ t, f: 'Anton', s: 104, up: true, col: 'accent' }],
    (t) => [{ t, f: 'Permanent Marker', s: 66 }, { forme: 'eclair', h: 30, col: 'accent', g: 6 }],
  ];
  function ajouterTendances(tf) {
    if (!tf) { biblio.modeles.forEach((m) => { if (m.tendance) m.saison = true; }); return; } // Tendances en pause
    if (biblio.categories.some((c) => c.id === 'tendances')) return;
    const duMois = new Set(tf.modeles || []);
    biblio.modeles.forEach((m) => { if (m.tendance) m.saison = !duMois.has(m.id); });
    if (!duMois.size && !tf.expressions?.length) return;
    const slug = (s) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    (tf.expressions || []).forEach((e, i) => {
      const lignes = STYLES[(e.style ?? i) % STYLES.length]('{texte}');
      if (e.forme && biblio.formes[e.forme]) lignes.unshift({ forme: e.forme, h: 46, col: 'accent' });
      biblio.modeles.push({ id: `tendance-${slug(e.texte)}`, cat: 'tendances', nom: e.texte, accent: { fonce: '#a3a3a3', clair: '#4b4b4b' }, champs: { texte: { label: ptxT("Texte"), defaut: e.texte } }, lignes });
    });
    biblio.categories.unshift({ id: 'tendances', nom: ptxT("Tendances") });
  }
  // « C'est pour… » : publics de chaque idée (thème, puis id ; m.pour dans le JSON l'emporte).
  const POUR = [['moi', 'moi'], ['cadeau', ptxT("un cadeau")], ['equipe', ptxT("mon équipe")], ['entreprise', ptxT("mon entreprise")], ['marque', ptxT("ma marque")]];
  const POUR_CAT = {
    evjf: ['equipe', 'cadeau'], anniversaire: ['cadeau', 'moi'], amour: ['cadeau'], famille: ['cadeau'], entreprise: ['entreprise', 'equipe'],
    association: ['equipe', 'entreprise'], sport: ['equipe'], ecole: ['equipe'], noel: ['cadeau', 'equipe'], vintage: ['marque', 'moi'],
    tendances: ['moi', 'marque', 'cadeau'], univers: ['moi', 'cadeau', 'marque'], halloween: ['moi', 'equipe'], 'nouvel-an': ['moi', 'entreprise'],
    'saint-valentin': ['cadeau'], 'grands-meres': ['cadeau'], paques: ['cadeau'], 'fete-meres': ['cadeau'], 'fete-peres': ['cadeau'],
    'fete-musique': ['equipe', 'moi'], fiertes: ['moi', 'equipe'], competition: ['equipe', 'moi'], rentree: ['equipe', 'cadeau'],
    'octobre-rose': ['equipe', 'moi', 'entreprise'], moustache: ['equipe', 'moi', 'entreprise'], 'solidarite-decembre': ['equipe', 'entreprise'],
    sidaction: ['equipe', 'moi'], 'droits-femmes': ['moi', 'equipe'], terre: ['moi', 'equipe', 'entreprise'], 'nouvel-an-lunaire': ['cadeau', 'moi'],
    'ramadan-aid': ['cadeau', 'moi'], hanoucca: ['cadeau', 'moi'],
  };
  const publics = (m) => {
    if (m.pour) return m.pour;
    const p = new Set(POUR_CAT[m.cat] || ['moi']);
    if (/team|staff|equipe|benevole|asso|club|bde|kermesse|classe/.test(m.id)) p.add('equipe');
    if (/entreprise|voeux|secret|fetes/.test(m.id)) p.add('entreprise');
    return [...p];
  };
  let pour = '';
  const enCeMoment = (tf, ici) => (tf && window.PrinttexTempsForts ? window.PrinttexTempsForts.periodes(tf, ici) : []);
  const modele = (id) => biblio?.modeles.find((m) => m.id === id);
  const echapper = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const defauts = (m) => Object.fromEntries(Object.entries(m.champs).map(([k, c]) => [k, c.defaut]));

  /* ---------- Construction d'un modèle (groupe Fabric) ---------- */
  function couleurs(m, props) {
    const fonce = !!P.state.fonce;
    const texte = props.couleur && props.couleur !== 'auto' ? props.couleur : (fonce ? '#ffffff' : '#000000');
    // Accent : une couleur, ou une paire { fonce, clair } choisie selon la teinte du vêtement (lot 24 : plus d'orange).
    const choix = (c) => (c && typeof c === 'object' ? (fonce ? c.fonce : c.clair) : c);
    const accent = choix(m.accent) || texte;
    return { texte, accent, accent2: choix(m.accent2) || accent, contour: fonce ? '#000000' : '#ffffff' };
  }

  function remplir(t, valeurs, up) {
    const s = t.replace(/\{(\w+)\}/g, (_, k) => (valeurs[k] ?? '').trim());
    return up ? s.toLocaleUpperCase('fr-FR') : s;
  }

  function forme(nom, h, couleur, w) {
    const f = biblio.formes[nom];
    if (!f) return null;
    const o = new fabric.Path(f.d, f.trait
      ? { fill: '', stroke: couleur, strokeWidth: f.trait, strokeLineCap: 'round', strokeLineJoin: 'round' }
      : { fill: couleur, stroke: null });
    const k = h / f.h;
    o.set({ scaleX: w ? w / f.w : k, scaleY: k, originX: 'center', originY: 'center' });
    if (w && f.trait) o.set({ strokeUniform: true, strokeWidth: f.trait * Math.min(k, 1.6) });
    return o;
  }

  async function element(l, m, valeurs, col) {
    if (l.forme) return forme(l.forme, l.h, l.col === 'accent2' || (l.col === 'accent' && !l.garde) ? col.accent2 : l.col === 'accent' ? col.accent : col.texte, l.w);
    if (l.bloc || l.pile) {
      const objs = (await Promise.all((l.bloc || l.pile).map((x) => element(x, m, valeurs, col)))).filter(Boolean);
      if (!objs.length) return null;
      let y = 0;
      objs.forEach((o, i) => {
        if (l.pile) { o.set({ left: l.pile[i].dx || 0, top: l.pile[i].dy || 0 }); return; }
        const h = o.getScaledHeight(); if (i) y += l.bloc[i].g ?? 6;
        o.set({ left: 0, top: y + h / 2 }); y += h;
      });
      return new fabric.Group(objs, { originX: 'center', originY: 'center' });
    }
    if (l.rang) {
      const objs = (await Promise.all(l.rang.map((x) => element(x, m, valeurs, col)))).filter(Boolean);
      if (!objs.length) return null;
      let x = 0;
      objs.forEach((o, i) => {
        const w = o.getScaledWidth();
        o.set({ left: x + w / 2, top: 0 });
        x += w + (i < objs.length - 1 ? 12 : 0);
      });
      const g = new fabric.Group(objs, { originX: 'center', originY: 'center' });
      const k = Math.min(1, (l.lw || LARGEUR) / g.width);
      g.set({ scaleX: k, scaleY: k });
      return g;
    }
    const text = remplir(l.t, valeurs, l.up);
    if (!text.replace(/[\s,&-]/g, '')) return null; // champ vidé : la ligne disparaît
    const p = {
      text, font: l.f, fill: l.col === 'accent2' ? col.accent2 : l.col === 'accent' ? col.accent : col.texte, size: l.s, curve: l.cv || 0, spacing: l.sp || 0,
      stroke: col.contour, strokeWidth: l.st || 0, bold: !!l.b, italic: !!l.i,
    };
    await P.ensureFont(p);
    let o = l.contour ? P.makeText({ ...p, fill: 'rgba(0,0,0,0)', stroke: p.fill, strokeWidth: l.contour }) : P.makeText(p);
    const autre = l.ombre === 'accent2' ? col.accent2 : l.col === 'accent' || l.col === 'accent2' ? col.texte : col.accent;
    if (l.om) { // ombre décalée
      const d = p.size * l.om;
      const ombre = P.makeText({ ...p, fill: autre, strokeWidth: 0 });
      ombre.set({ left: d, top: d }); o.set({ left: 0, top: 0 });
      o = new fabric.Group([ombre, o], { originX: 'center', originY: 'center' });
    }
    if (l.echo) { // copies en contour au-dessus
      const copies = [];
      for (let i = l.echo; i >= 1; i -= 1) {
        const c = P.makeText({ ...p, fill: 'rgba(0,0,0,0)', stroke: autre, strokeWidth: Math.max(1.5, p.size / 40) });
        c.set({ left: 0, top: -i * p.size * 0.74 });
        copies.push(c);
      }
      o.set({ left: 0, top: 0 });
      o = new fabric.Group([...copies, o], { originX: 'center', originY: 'center' });
    }
    // Texte long : réduit pour rester dans la largeur du modèle (jamais coupé).
    const k = Math.min(1, (l.lw || LARGEUR) / o.width);
    o.set({ scaleX: k, scaleY: k, originX: 'center', originY: 'center' });
    return o;
  }

  async function construire(props) {
    const m = modele(props.id);
    const col = couleurs(m, props);
    const objs = [];
    let y = 0;
    for (const l of m.lignes) {
      const o = await element(l, m, props.valeurs, col);
      if (!o) continue;
      const h = o.getScaledHeight();
      if (objs.length) y += l.g ?? 6;
      o.set({ left: 0, top: y + h / 2 });
      y += h;
      objs.push(o);
    }
    if (!objs.length) objs.push(new fabric.Text(' ', { fontSize: 20, originX: 'center', originY: 'center' }));
    const g = new fabric.Group(objs, { originX: 'center', originY: 'center' });
    g.ppType = 'modele';
    g.ppProps = { id: props.id, valeurs: { ...props.valeurs }, couleur: props.couleur || 'auto', fonce: !!P.state.fonce };
    return g;
  }

  /* ---------- Pose, modification, remplacement ---------- */
  function poser(c, g, ancien) {
    if (ancien) {
      g.set({ scaleX: ancien.scaleX, scaleY: ancien.scaleY, angle: ancien.angle, flipX: ancien.flipX });
      g.setPositionByOrigin(ancien.getCenterPoint(), 'center', 'center');
      const idx = c.getObjects().indexOf(ancien);
      const avant = P.state.restoring;
      P.state.restoring = true; // un seul point d'historique par modification
      c.remove(ancien);
      c.insertAt(g, idx);
      P.state.restoring = avant;
    } else {
      // Nouveau modèle : bien visible au centre de la zone (80 % de large, 70 % de haut au plus).
      const W = P.LOGICAL_W; const H = P.logicalH(P.state.side);
      const k = Math.min((W * 0.8) / g.width, (H * 0.7) / g.height);
      g.set({ scaleX: k, scaleY: k, left: W / 2, top: H * 0.42 });
      c.add(g);
    }
    P.fitInZone(g); // jamais hors de la zone
  }

  async function ajouter(id) {
    // « Nom et numéro (dos) » : un seul parcours, le mode Équipe de l'onglet Tailles (printtex-equipe-outil.js).
    if (id === 'sport-dos' && window.PrinttexEquipe) { window.PrinttexEquipe.ouvrir(); return; }
    await charger();
    const m = modele(id);
    const actuel = P.active();
    const remplace = actuel?.ppType === 'modele' ? actuel : null;
    // Modèle du dos (nom + numéro) : posé au dos si le produit en a un.
    if (!remplace && m.cote === 'dos' && P.state.side !== 'dos' && P.state.canvases.dos && (!P.data.sides || P.data.sides.includes('dos'))) P.setSide('dos');
    // Les valeurs déjà tapées sont gardées quand on passe d'un modèle à l'autre (même champ).
    const valeurs = defauts(m);
    if (remplace) Object.keys(valeurs).forEach((k) => { if (remplace.ppProps.valeurs[k] != null) valeurs[k] = remplace.ppProps.valeurs[k]; });
    const g = await construire({ id, valeurs, couleur: remplace?.ppProps.couleur || 'auto' });
    const c = P.canvas();
    poser(c, g, remplace);
    c.setActiveObject(g);
    c.requestRenderAll();
    P.snapshot();
    P.onSelection();
    P.updatePrice();
    $('[data-ppm-champs] input')?.focus({ preventScroll: true });
  }

  let job = Promise.resolve();
  let histo;
  function modifier(change) {
    job = job.then(async () => {
      const obj = P.active();
      if (obj?.ppType !== 'modele') return;
      const props = { ...obj.ppProps, valeurs: { ...obj.ppProps.valeurs } };
      change(props);
      const g = await construire(props);
      const c = P.canvas();
      poser(c, g, obj);
      c.setActiveObject(g);
      c.requestRenderAll();
      P.onSelection();
      clearTimeout(histo);
      histo = setTimeout(() => P.snapshot(), 600);
    });
  }

  // Recrée tous les modèles d'une zone (police chargée, couleur du vêtement changée).
  async function recreer(c, seulementAuto) {
    const liste = c.getObjects().filter((o) => o.ppType === 'modele' && o.ppProps && modele(o.ppProps.id)
      && (!seulementAuto || ((o.ppProps.couleur || 'auto') === 'auto' && o.ppProps.fonce !== !!P.state.fonce)));
    for (const o of liste) {
      const g = await construire(o.ppProps);
      poser(c, g, o);
    }
    if (liste.length) c.requestRenderAll();
    return liste.length;
  }

  /* ---------- Onglet « Idées » ---------- */
  const $ = (s) => P.$(s);
  const ICONE = '<svg class="pp-svg" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.6 10.8c.7.5 1.1 1.3 1.1 2.2h5c0-.9.4-1.7 1.1-2.2A6 6 0 0 0 12 3z"/></svg>';

  function installer() {
    P = window.PrinttexPerso;
    if (!P || $('[data-pp-tab="idees"]')) return;
    const texte = $('[data-pp-tab="texte"]');
    const onglet = document.createElement('button');
    onglet.type = 'button';
    onglet.dataset.ppTab = 'idees';
    onglet.setAttribute('role', 'tab');
    onglet.innerHTML = `${ICONE}<span>${ptxT("Idées")}</span>`;
    texte.parentNode.insertBefore(onglet, texte);
    texte.parentNode.classList.add('ppm-5');
    onglet.addEventListener('click', () => { P.setTab('idees'); ouvrir(); });

    const panneau = document.createElement('section');
    panneau.className = 'pp-panel ppm';
    panneau.dataset.ppPanel = 'idees';
    panneau.hidden = true;
    panneau.innerHTML = `
      <div class="ppm-edit" data-ppm-edit hidden>
        <p class="ppm-titre">${ptxT("Votre modèle :")} <strong data-ppm-nom></strong></p>
        <div class="ppm-champs" data-ppm-champs></div>
        <p class="ppm-label">${ptxT("Couleur du texte")}</p>
        <div class="ppm-couleurs" data-ppm-couleurs></div>
        <p class="pp-note">${ptxT("Déplacez-le ou agrandissez-le sur le vêtement. Il reste toujours dans la zone d'impression.")}</p>
        <p class="ppm-label">${ptxT("Changer de modèle (vos textes sont gardés)")}</p>
      </div>
      <p class="pp-note ppm-intro" data-ppm-intro>${ptxT("Choisissez un modèle, puis remplacez les textes par les vôtres.")}</p>
      <div class="ppm-pour" data-ppm-pour role="group" aria-label="${ptxT("C'est pour")}"></div>
      <div class="ppm-cats" data-ppm-cats role="group" aria-label="${ptxT("Thèmes")}"></div>
      <div class="ppm-grille" data-ppm-grille><p class="pp-note">${ptxT("Chargement des modèles…")}</p></div>`;
    const panels = $('[data-pp-panel="texte"]').parentNode;
    panels.insertBefore(panneau, $('[data-pp-panel="texte"]'));

    P.ext.selection.push(selection);
    P.ext.restaurer.push(async (c) => { await charger(); await recreer(c, false); });
    P.ext.couleur.push(async () => {
      if (!biblio) return;
      for (const side of Object.keys(P.state.canvases)) {
        if (await recreer(P.state.canvases[side], true)) P.snapshot(side);
      }
      if (!P.$('[data-pp-panel="idees"]').hidden) vignettes();
    });
  }

  async function ouvrir() {
    await charger();
    if (!$('[data-ppm-cats]').children.length) {
      const moment = biblio.moment || [];
      const idsMoment = new Set(moment.flatMap((p) => p.idees));
      if (moment.length && filtre === 'tout') filtre = 'moment';
      const cats = [...(moment.length ? [{ id: 'moment', nom: `${ptxT("En ce moment :")} ${moment.map((p) => p.nom).join(', ')}` }] : []), { id: 'tout', nom: ptxT("Tout") }, ...biblio.categories];
      if (moment.length) $('[data-ppm-intro]').innerHTML = `<strong>${ptxT("En ce moment :")} ${echapper(moment.map((p) => p.nom).join(', '))}.</strong> ${ptxT("Touchez une idée : elle se place sur le vêtement, puis changez les textes.")}`;
      const visibles = biblio.modeles.filter((m) => !m.saison || idsMoment.has(m.id))
        .sort((x, y) => (idsMoment.has(y.id) ? 1 : 0) - (idsMoment.has(x.id) ? 1 : 0));
      const montrer = () => P.$$('[data-ppm-id]').forEach((x) => {
        x.hidden = (filtre === 'moment' ? x.dataset.ppmMoment !== '1' : filtre !== 'tout' && x.dataset.ppmCat !== filtre)
          || (!!pour && !x.dataset.ppmPour.split(' ').includes(pour));
      });
      $('[data-ppm-cats]').innerHTML = cats.map((c) => `<button type="button" data-ppm-cat="${c.id}" class="${c.id === filtre ? 'is-active' : ''}">${echapper(c.nom)}</button>`).join('');
      $('[data-ppm-pour]').innerHTML = `<span>${ptxT("C'est pour :")}</span>${POUR.map(([id, nom]) => `<button type="button" data-ppm-pour-id="${id}" aria-pressed="false">${nom}</button>`).join('')}`;
      $('[data-ppm-pour]').addEventListener('click', (e) => {
        const b = e.target.closest('[data-ppm-pour-id]');
        if (!b) return;
        pour = pour === b.dataset.ppmPourId ? '' : b.dataset.ppmPourId; // second toucher : retire le filtre
        P.$$('[data-ppm-pour-id]').forEach((x) => { const on = x.dataset.ppmPourId === pour; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on); });
        if (pour && filtre !== 'tout') { filtre = 'tout'; P.$$('.ppm-cats [data-ppm-cat]').forEach((x) => x.classList.toggle('is-active', x.dataset.ppmCat === 'tout')); }
        montrer();
      });
      $('[data-ppm-cats]').addEventListener('click', (e) => {
        const b = e.target.closest('[data-ppm-cat]');
        if (!b) return;
        filtre = b.dataset.ppmCat;
        P.$$('.ppm-cats [data-ppm-cat]').forEach((x) => x.classList.toggle('is-active', x === b));
        montrer();
      });
      $('[data-ppm-grille]').innerHTML = visibles.map((m) => `
        <button type="button" class="ppm-carte" data-ppm-id="${m.id}" data-ppm-cat="${m.cat}" data-ppm-moment="${idsMoment.has(m.id) ? 1 : 0}" data-ppm-pour="${publics(m).join(' ')}">
          <span class="ppm-vignette"><img alt="" width="240" height="160" hidden></span>
          <span class="ppm-carte__nom">${echapper(m.nom)}</span>
        </button>`).join('');
      $('[data-ppm-grille]').addEventListener('click', (e) => {
        const b = e.target.closest('[data-ppm-id]');
        if (b) ajouter(b.dataset.ppmId);
      });
      montrer();
    }
    vignettes();
  }

  // Aperçu de chaque modèle, dessiné avec les vraies polices, dans la couleur adaptée au vêtement choisi.
  let vignJob = Promise.resolve();
  function vignettes() {
    const fonce = !!P.state.fonce;
    if (vignettesFonce === fonce) return;
    vignettesFonce = fonce;
    $('[data-ppm-grille]').classList.toggle('is-fonce', fonce);
    vignJob = vignJob.then(async () => {
      const el = document.createElement('canvas');
      const sc = new fabric.StaticCanvas(el, { width: 240, height: 160, enableRetinaScaling: false });
      for (const m of biblio.modeles) {
        if (!$(`[data-ppm-id="${m.id}"]`)) continue;
        const g = await construire({ id: m.id, valeurs: defauts(m), couleur: 'auto' });
        const k = Math.min(212 / g.width, 136 / g.height);
        g.set({ scaleX: k, scaleY: k, left: 120, top: 80 });
        sc.clear();
        sc.add(g);
        sc.renderAll();
        const img = $(`[data-ppm-id="${m.id}"] img`);
        if (img) { img.src = sc.toDataURL({ format: 'png', multiplier: 1 }); img.hidden = false; }
      }
      sc.dispose();
    });
  }

  function selection(obj) {
    const edit = $('[data-ppm-edit]');
    if (!edit) return;
    if (obj?.ppType !== 'modele' || !biblio) {
      edit.hidden = true;
      $('[data-ppm-intro]').hidden = false;
      return;
    }
    const m = modele(obj.ppProps.id);
    if (!m) return;
    if (P.state.tab !== 'idees') { P.setTab('idees'); ouvrir(); }
    edit.hidden = false;
    $('[data-ppm-intro]').hidden = true;
    $('[data-ppm-nom]').textContent = m.nom;
    const box = $('[data-ppm-champs]');
    if (box.dataset.id !== m.id) {
      box.dataset.id = m.id;
      box.innerHTML = Object.entries(m.champs).map(([k, c]) => `
        <label class="ppm-champ"><span>${echapper(c.label)}</span>
          <input type="text" class="pp-input" data-ppm-champ="${k}" maxlength="${c.max || 40}" ${c.chiffres ? 'inputmode="numeric"' : ''} autocomplete="off"></label>`).join('');
      box.querySelectorAll('[data-ppm-champ]').forEach((input) => input.addEventListener('input', () => {
        const k = input.dataset.ppmChamp;
        const v = (m.champs[k].chiffres ? input.value.replace(/\D/g, '') : input.value).slice(0, m.champs[k].max || 40);
        if (v !== input.value) input.value = v;
        modifier((p) => { p.valeurs[k] = v; });
      }));
    }
    // Ne pas réécrire le champ en cours de saisie.
    box.querySelectorAll('[data-ppm-champ]').forEach((input) => {
      if (document.activeElement !== input) input.value = obj.ppProps.valeurs[input.dataset.ppmChamp] ?? '';
    });
    const cols = $('[data-ppm-couleurs]');
    if (!cols.children.length) {
      cols.innerHTML = `<button type="button" class="ppm-auto" data-ppm-couleur="auto">Auto</button>` +
        P.COLORS.map((c) => `<button type="button" class="pp-color" data-ppm-couleur="${c}" style="background:${c}" aria-label="Couleur ${c}"></button>`).join('');
      cols.addEventListener('click', (e) => {
        const b = e.target.closest('[data-ppm-couleur]');
        if (b) modifier((p) => { p.couleur = b.dataset.ppmCouleur; });
      });
    }
    const actuelle = obj.ppProps.couleur || 'auto';
    cols.querySelectorAll('[data-ppm-couleur]').forEach((b) => b.classList.toggle('is-active', b.dataset.ppmCouleur === actuelle));
  }

  // Commande d'équipe (printtex-equipe-outil.js) : un nom + numéro différent par personne.
  window.PrinttexModeles = { charger, construire, poser, modele, ajouter, enCeMoment };

  async function ligneFiche() {
    const ancre = document.querySelector('[data-pp-grille]') || document.querySelector('.pp-cta__pdl') || document.querySelector('.pp-cta__btn'); // Design, lot 30 : après le tableau des prix, pas sous le bouton
    if (!ancre || document.querySelector('[data-ppm-fiche]')) return;
    await charger().catch(() => null);
    const moment = biblio?.moment || [];
    if (!moment.length) return;
    const p = document.createElement('p');
    p.className = 'ppm-fiche';
    p.dataset.ppmFiche = '';
    p.innerHTML = `<span>${ptxT("Idées du moment :")}</span> <button type="button">${echapper(moment.map((x) => x.resume || x.nom).join(', '))}</button>`;
    p.querySelector('button').addEventListener('click', () => ouvrirIdees());
    ancre.after(p);
  }
  // Ouvre l'outil sur l'onglet Idées (filtre « En ce moment »), et pose l'idée demandée s'il y en a une.
  function ouvrirIdees(id) {
    filtre = 'moment';
    document.querySelector('[data-pp-open]')?.click();
    let n = 0;
    const t = setInterval(async () => {
      const m = document.querySelector('.pp-modal');
      const onglet = document.querySelector('.pp-tabs [data-pp-tab="idees"]');
      n += 1;
      if (!(m && !m.hidden && onglet && P)) {
        if (n % 7 === 0) document.querySelector('[data-pp-open]')?.click(); // outil pas encore prêt : nouvel essai
        if (n < 80) return;
      }
      clearInterval(t);
      if (!onglet?.classList.contains('is-active')) onglet?.click();
      setTimeout(() => P?.tiroir?.('plein'), 250);
      if (id) { await charger(); if (modele(id)) setTimeout(() => ajouter(id), 400); }
    }, 150);
  }
  // Lien direct (accueil, collections) : /products/<produit>?idees=1&modele=<id>
  const lien = new URLSearchParams(location.search);
  // … ou /products/<produit>#idees (cartes « En ce moment » de l'accueil et des collections), aussi sans rechargement.
  const parAncre = () => location.hash === '#idees';
  if (lien.has('idees') || parAncre()) {
    const go = () => ouvrirIdees(lien.get('modele'));
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }
  window.addEventListener('hashchange', () => { if (parAncre()) ouvrirIdees(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligneFiche); else ligneFiche();

  if (window.PrinttexPerso) installer();
  else document.addEventListener('pp:pret', installer);
})();
